import useAnalytics from './useAnalytics'

interface ContactActionOptions {
  component?: string
  description?: string
  targetId?: string
}

export const useContactAction = (options?: ContactActionOptions) => {
  const { fireEvent } = useAnalytics()

  const handleClick = (redirectToTarget?: boolean) => {
    if (redirectToTarget && options?.targetId) {
      const el = document.getElementById(options.targetId)
      if (el) el.scrollIntoView({ behavior: 'smooth' })

      fireEvent('send_contact', {
        component: options?.component,
        target: 'linkContactSection',
        description: options?.description,
      })
    } else {
      fireEvent('send_contact', {
        component: options?.component,
        target: 'linkWhatsapp',
        description: options?.description,
      })
      fireEvent('externalClick', {
        component: options?.component,
        target: 'linkWhatsapp',
        description: options?.description,
      })
    }
  }

  return { handleClick }
}
